// Schema + builder helpers for the syndicate-submission RPC. Imported by
// both the worker validator (functions/_shared.js, functions/api/submit.js)
// and the client request builder (src/components/App/App.js) so the two
// sides share one source of truth for which keys are on the wire.
//
// To add a field: add it to the relevant key-list AND thread it through
// the matching builder. Both ends pick it up automatically — the
// validator allows it, the builder forwards it.

export const BODY_KEYS = [
  "marcId",
  "eggId",
  "initials",
  "source",
  "elapsedMs",
  "strokes",
  "palette",
  "overrides",
];

export const PEN_ERASER_STROKE_KEYS = [
  "tool",
  "colorIndex",
  "color",
  "size",
  "points",
];
export const FILL_STROKE_KEYS = [
  "tool",
  "colorIndex",
  "color",
  "bbox",
  "maskPng",
];
export const BBOX_KEYS = ["x", "y", "w", "h"];
export const POINT_KEYS = ["x", "y", "pressure"];

export const OVERRIDES_KEYS = [
  "eggTransform",
  "marcTransform",
  "eggLights",
  "warmth",
  "redshift",
];
export const EGG_TRANSFORM_KEYS = ["tx", "ty", "scale", "scaleX", "rotation"];
export const MARC_TRANSFORM_KEYS = ["tx", "ty", "scale", "rot"];
export const LIGHT_KEYS = ["direction", "intensity", "shadow", "size"];
export const DIRECTION_KEYS = ["x", "y", "z"];

function pickKeys(src, keys) {
  const out = {};
  for (const k of keys) {
    if (src[k] !== undefined) out[k] = src[k];
  }
  return out;
}

export function buildSubmissionBody(src) {
  return pickKeys(src, BODY_KEYS);
}

export function buildOverrides(src) {
  return pickKeys(src, OVERRIDES_KEYS);
}
